/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ArticleSortEnum {
  new = "new",
  priceASC = "priceASC",
  priceDESC = "priceDESC",
}

export enum TourName {
  diamond_and_champagne_tour = "diamond_and_champagne_tour",
  diamond_experience_tour = "diamond_experience_tour",
  diamond_polishing_experience_tour = "diamond_polishing_experience_tour",
  gassan_vip_tour = "gassan_vip_tour",
}

export interface AddressInput {
  first_name: string;
  last_name: string;
  company_name?: string | null;
  phone_number?: string | null;
  line_1: string;
  line_2?: string | null;
  city: string;
  postcode: string;
  county: string;
  country: string;
}

export interface ArticlesFilterInput {
  attributeFilters?: AttributeFilterFiltersInput[] | null;
  brands?: number[] | null;
  collections?: number[] | null;
  articleTypeID?: number | null;
  theme?: string | null;
}

export interface ArticlesPaginationInput {
  sort?: ArticleSortEnum | null;
  skip?: number | null;
  limit?: number | null;
}

export interface AttributeFilterFiltersInput {
  attributeID: number;
  attributeValueID: number[];
}

export interface CheckoutAsGuestInput {
  customer: CheckoutCustomerInput;
  billingAddress: AddressInput;
  shippingAddress?: AddressInput | null;
}

export interface CheckoutAsUserInput {
  billingAddressId: string;
  shippingAddressId?: string | null;
}

export interface CheckoutCustomerInput {
  email: string;
  name: string;
}

export interface CheckoutMetaInput {
  wrapping?: boolean | null;
  wrappingText?: string | null;
  delivery?: string | null;
  message?: string | null;
  newsletterSignup?: boolean | null;
  salutation?: string | null;
}

export interface ContactFormInput {
  salutation?: string | null;
  name: string;
  email: string;
  referrer: string;
  subject?: string | null;
  type?: string | null;
  phone?: string | null;
  preferredDate?: string | null;
  message?: string | null;
}

export interface ContactFormStoreInput {
  store: string;
  location: string;
}

export interface NewsletterSignupInput {
  salutation: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string | null;
  birthdate?: string | null;
  gassanNewsletter?: boolean | null;
  choicesNewsletter?: boolean | null;
  signedUpFrom?: string | null;
}

export interface PaymentDetailsInput {
  paymentData: string;
  MD: string;
  PaRes: string;
}

export interface PaymentGiftcardInput {
  giftcardNumber: string;
  securityCode: string;
  amount: number;
}

export interface PaymentInput {
  orderId: string;
  paymentMethod?: any | null;
  returnUrl: string;
  giftcard?: PaymentGiftcardInput | null;
  paypalOrderId?: string | null;
  shopperIP?: string | null;
  browserInfo?: any | null;
}

export interface ReturnItem {
  id?: string | null;
  reason?: string | null;
}

export interface ReturnOrderRequestInput {
  email: string;
  orderId: string;
  items: ReturnItem[];
}

export interface TourBookingClientInput {
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  hotel: string;
  countryOfOrigin?: string | null;
  message?: string | null;
}

export interface TourBookingInput {
  date: string;
  time: string;
  type?: string | null;
  name: TourName;
  persons: number;
  prefferedLanguage: string;
}

export interface TourBookingTourOperatorInput {
  tourLeader: string;
  localGuide: string;
  travelAgency: string;
  clientName: string;
  email: string;
  phone: string;
  hotel: string;
  message?: string | null;
}

export interface TourCheckoutInput {
  email: string;
  firstName: string;
  lastName: string;
  tourCodename: string;
  persons: number;
}

export interface ValidateGiftCardInput {
  giftcardNumber: string;
  securityCode: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
